<template>
	<div class="d21-services-tick">
		<ul class="d21-ticks" v-for="(tickGroup, tickGroupX) in tickGroups" :key="'tickGroup_' + tickGroupX">
			<li v-for="tick in tickGroup.Ticks" :key="tick.Value" :class="{ 'd21-tick-isAvailable': tick.IsAvailable, 'd21-tick-isUnavailable': tick.IsEnabled && !tick.IsAvailable, 'd21-tick-isSelected': tick.IsSelected, 'd21-tick-isDisabled': !tick.IsEnabled }" @click="selectTick(tick)">
				{{ tick.Text }}
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			tickGroups: {
				type: Array,
				default: () => [],
			}
		},
		methods: {
			selectTick(tick) {
				this.$emit("select", tick);
			}
		}
	}
</script>